"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5513],{

/***/ 55227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52261);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n    @media only screen and (max-width: 768px) {\n      width: ",
        ";\n      height: ",
        ";\n      display: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Spacer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ca589eee-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, direction = param.direction, size = param.size, sizeMobile = param.sizeMobile, hideMobile = param.hideMobile;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), direction === "horizontal" ? theme.spacings[size] || theme.spacings.spacing_m : "auto", direction === "horizontal" ? "auto" : theme.spacings[size] || theme.spacings.spacing_m, direction === "horizontal" ? theme.spacings[sizeMobile] || theme.spacings[size] || theme.spacings.spacing_m : "auto", direction === "horizontal" ? "auto" : theme.spacings[sizeMobile] || theme.spacings[size] || theme.spacings.spacing_m, hideMobile ? "none" : "block");
});
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);


/***/ }),

/***/ 55243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Meta_MetaCommon; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/Meta/index.js



var Meta = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: props.title || "Classy Closets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: "7jLw51OmKOuP0MvIAQoCjmNhMWPDue5WmED3bCTMK9Q"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "p:domain_verify",
                content: "a12b5e25ff60d6781cafa414f43c8f22"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: props.desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: props.robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "ou4n966cf2cpa6d4jzrf57tiejnd0u"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:title",
                property: "og:title",
                content: props.title || "Classy Closets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:description",
                property: "og:description",
                content: props.desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Classy Closets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "".concat(props.canonical)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:label1",
                content: "Written by"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:data1",
                content: "Classy Closets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:label2",
                content: "Est. reading time"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: props.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: props.desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "@classyclosets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: "@classyclosets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/static/images/favicon.ico"
            }),
            props.css && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "stylesheet",
                href: "".concat(props.css)
            }),
            props.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "classyclosets:image",
                content: "".concat(props.image)
            }),
            props.canonical && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "".concat(props.canonical)
            }),
            props.js && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "".concat(props.js)
            })
        ]
    });
};
/* harmony default export */ var components_Meta = (Meta);

// EXTERNAL MODULE: ./data/_metaData.js
var _metaData = __webpack_require__(66080);
;// CONCATENATED MODULE: ./components/Meta/MetaCommon.js



var MetaCommon = function(param) {
    var metaDataKey = param.metaDataKey, customMetaData = param.customMetaData;
    var pageMetaData = !metaDataKey ? customMetaData : _metaData/* default.hasOwnProperty */.Z.hasOwnProperty(metaDataKey) ? _metaData/* default */.Z[metaDataKey] : _metaData/* default.home */.Z.home;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Meta, {
        title: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.title,
        desc: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.description,
        canonical: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.canonical,
        robots: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.robots
    });
};
/* harmony default export */ var Meta_MetaCommon = (MetaCommon);


/***/ }),

/***/ 33940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResponsiveImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62230);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13273);





function ResponsiveImage(param) {
    var mobile = param.mobile, desktop = param.desktop;
    var isSmallDevice = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isSmallDevice;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDesktop = ref[0], setIsDesktop = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsDesktop(window.innerWidth > 768);
    }, [
        isSmallDevice
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            alt: "Image"
        }, desktop)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            alt: "Image"
        }, mobile))
    });
}


/***/ }),

/***/ 26058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CounterTopsPage_Reviews; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Typography/index.js
var Typography = __webpack_require__(59757);
// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(30023);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/ImgBanner/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  @media only screen and (max-width: 560px) {\n    height: 254px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 83px;\n  left: ",
        ";\n\n  @media only screen and (max-width: 768px) {\n    left: ",
        ";\n  }\n  @media only screen and (max-width: 560px) {\n    bottom: 35px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: fit-content;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "Lora Medium";\n  font-size: 40px;\n  color: ',
        ";\n  margin-top: -50px;\n  padding-left: 6px;\n  padding-right: 12px;\n\n  @media only screen and (max-width: 768px) {\n    font-size: 32px;\n    margin-top: -39px;\n  }\n  @media only screen and (max-width: 560px) {\n    font-size: 30px;\n    margin-top: -37px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 28px;\n  width: 100%;\n  background-color: #ffffffaa;\n  width: 100%;\n\n  @media only screen and (max-width: 768px) {\n    height: 22px;\n  }\n  @media only screen and (max-width: 560px) {\n    height: 18px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f4262f7-0"
})(_templateObject());
var SummaryWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f4262f7-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_big;
}, function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_xxl_m;
});
var SummaryFirst = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f4262f7-2"
})(_templateObject2());
var SummaryText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f4262f7-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.blackGreen;
});
var BgColorDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f4262f7-4"
})(_templateObject4());

// EXTERNAL MODULE: ./components/Responsive/Image.js
var Image = __webpack_require__(33940);
;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/ImgBanner/index.js





var ImgBanner = function(param) {
    var image = param.image;
    var _image = image || {
        mobile: {
            alt: "corner desk with white accents",
            src: "/images/countertops/reviews-background-mobile.jpg",
            layout: "responsive",
            loading: "lazy",
            quality: 60,
            width: "390",
            height: "534"
        },
        desktop: {
            alt: "corner desk with white accents",
            src: "/images/countertops/reviews-background.jpg",
            layout: "responsive",
            loading: "lazy",
            quality: 60,
            width: "1920",
            height: "628"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({}, _image))
    });
};
/* harmony default export */ var Reviews_ImgBanner = (ImgBanner);

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/react-slick/lib/index.js
var lib = __webpack_require__(23467);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(17064);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/ReviewsSlider/Review/styled.js

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  box-shadow: 0px 3px 6px ",
        ";\n  background-color: ",
        ";\n  min-height: 270px;\n  max-height: ",
        ";\n  overflow: ",
        ";\n\n  @media only screen and (max-width: 560px) {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "Montserrat";\n  font-size: 12px;\n  font-style: normal;\n  color: ',
        ";\n  padding-bottom: 10px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  @media only screen and (max-width: 768px) {\n    font-size: 14px;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cb5f371-0"
})(styled_templateObject());
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cb5f371-1"
})(styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_xl;
}, function(param) {
    var theme = param.theme;
    return theme.colors.shadow2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var $size = param.$size;
    return $size ? "fit-content" : "270px";
}, function(param) {
    var $size = param.$size;
    return $size ? "visible" : "hidden";
});
var CustomerName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cb5f371-2"
})(styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.textStyles.titleSmall1;
});
var ShortSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cb5f371-3"
})(styled_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.blackGreen;
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cb5f371-4"
})(styled_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.textStyles.content4;
});

;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/ReviewsSlider/Review/index.js





var Review = function(param) {
    var name = param.name, shortSummary = param.shortSummary, content = param.content;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), show = ref[0], setShowMore = ref[1];
    var showMore = function() {
        setShowMore(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            onClick: showMore,
            $size: show,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerName, {
                    children: name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortSummary, {
                    children: shortSummary
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        '"',
                        content,
                        '"'
                    ]
                })
            ]
        })
    });
};
Review.propTypes = {
    name: (prop_types_default()).string,
    shortSummary: (prop_types_default()).string,
    content: (prop_types_default()).string
};
/* harmony default export */ var ReviewsSlider_Review = (Review);

;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/ReviewsSlider/styled.js

function ReviewsSlider_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: -10px;\n  margin-right: -10px;\n  padding-bottom: 74px;\n  & .slick-slider {\n    .slick-dots {\n      li > button {\n        &::before {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 560px) {\n    margin-top: -30px;\n    padding-bottom: 40px;\n  }\n"
    ]);
    ReviewsSlider_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ReviewsSlider_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1329212b-0"
})(ReviewsSlider_styled_templateObject());

// EXTERNAL MODULE: ./data/reviewsData.js
var reviewsData = __webpack_require__(88311);
;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/ReviewsSlider/index.js








var ReviewsSlider = function() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSlider_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: reviewsData/* default.map */.Z.map(function(review, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSlider_Review, {
                        name: review.name,
                        shortSummary: review.shortSummary,
                        content: review.content
                    })
                }, key);
            })
        }))
    });
};
/* harmony default export */ var Reviews_ReviewsSlider = (ReviewsSlider);

;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/styled.js

function Reviews_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-bottom: 300px;\n  @media only screen and (max-width: 768px) {\n    margin-bottom: 400px;\n  }\n"
    ]);
    Reviews_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Reviews_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 200px;\n  width: 100%;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n\n  @media only screen and (max-width: 768px) {\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n  @media only screen and (max-width: 560px) {\n    padding-left: 18px;\n    padding-right: 18px;\n    top: 100px;\n  }\n"
    ]);
    Reviews_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Reviews_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ffffffaa;\n  width: calc(\n    100% +\n      ",
        "px\n  );\n  transform: translateX(\n    -",
        "px\n  );\n  @media only screen and (max-width: 768px) {\n    width: 100%;\n    transform: none;\n    margin-bottom: 30px;\n  }\n"
    ]);
    Reviews_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Reviews_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 4px solid ",
        ";\n  padding: 20px 60px;\n\n  @media only screen and (max-width: 768px) {\n    padding: 20px 30px;\n  }\n"
    ]);
    Reviews_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Reviews_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a46a7ba-0"
})(Reviews_styled_templateObject());
var SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a46a7ba-1"
})(Reviews_styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
});
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a46a7ba-2"
})(Reviews_styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop * 2 + 128;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop + 64;
});
var SliderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a46a7ba-3"
})(Reviews_styled_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.darkGray2;
});

;// CONCATENATED MODULE: ./containers/CounterTopsPage/Reviews/index.js







var Reviews = function(param) {
    var image = param.image;
    var isSmallDevice = (0,hooks/* useWindowDimensions */.dz)().isSmallDevice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Reviews_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ImgBanner, {
                image: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontType: "header",
                                fontWeight: "bold",
                                fontSize: !isSmallDevice ? "3rem" : "1.5rem",
                                textAlign: "center",
                                children: "What our customers are saying:"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewsSlider, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CounterTopsPage_Reviews = (Reviews);


/***/ }),

/***/ 88311:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ([
    {
        id: 1,
        name: "Sheilah S",
        date: "9/07/2022",
        location: "Phoenix",
        shortSummary: "We love our closet!",
        content: "We were having a difficult time finding someone to complete our master bedroom closet until I called Classy Closets and spoke with Hannah. I am so grateful the other two options didn't work out, because working with Hannah has been the highlight of our home's construction experiences."
    },
    {
        id: 2,
        name: "Julie H",
        date: "8/22/2022",
        location: "Gilbert",
        shortSummary: "Good Design For Our Space",
        content: "Our master bedroom closet is on the small side. Heather listened to our needs and created a design that gives more hanging space for clothes, space for shoes , a set of drawers that gives us more storage and a tidy, no clutter appearance...  Thank you!"
    },
    {
        id: 3,
        name: "Nicole S",
        date: "8/12/2022",
        location: "Chandler",
        shortSummary: "Beautiful Bedroom Closets",
        content: "These are the most beautiful closets I have had installed. Cheyenne Holt has incredible taste and created amazing closets for us"
    },
    {
        id: 4,
        name: "Paul M",
        date: "8/12/2022",
        location: "Venice CA",
        shortSummary: "Thank you for a great job!",
        content: "We had Classy Closets create new cabinets for our garage. It turned out very nice and we are so pleased with how easy it was to work with Hannah in the design and how seamless the installation went."
    },
    {
        id: 5,
        name: "Heather C",
        date: "5/6/2022",
        location: "Carlsbad CA",
        shortSummary: "Service with smiles",
        content: "Classy Closets has great customer service - leaving our residents extremely happy. Kellin, Heather, Derrick, and Levi are quite the team. "
    },
    {
        id: 6,
        name: "Dan C",
        date: "12/26/2018",
        location: "Gilbert",
        shortSummary: "Amazing work at my house",
        content: "Thank you again for the amazing work you and your team did at my house. I’ve dealt with many contractors and never have I had an experience like the one I had with you. You guys made sure that I knew exactly when you would be there, were right on time, did an incredible job."
    },
    {
        id: 7,
        name: "Angie W",
        date: "9/13/2017",
        location: "Surprise, AZ",
        shortSummary: "Excellent everything",
        content: "We enjoyed working with the Classy Closets crew, along with Hannah and Emily. The design was fabulous and the installers were great!! We can highly recommend them."
    }, 
]);


/***/ })

}]);